import { useCallback, useEffect, useState } from "react";
import { getAllStores, updateStore } from "../../services/AllServices";
import { showMessage } from "../../utils/helpers";
import { useNavigate } from "react-router-dom";

const useHomeViewController = () => {
  const [storesData, setStoresData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchQuery, setSearchQuery] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [clickedIndex, setClickedIndex] = useState(null);
  const [toggleStatus, setToggleStatus] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 15;
  const totalPages = Math.ceil(totalCount / pageSize);


  const handlePageChange = (page) => {
    if (page > totalPages || page < 1) {
      return;
    }
    setCurrentPage(page);
  };

  const handleSearch = () => {
    if (searchText.trim()) {
      setCurrentPage((prevpage) => {
        setSearchQuery(searchText);
        return 1;
      });
    }
  };

  const fetchData = useCallback(async (page = currentPage, query = searchQuery) => {
    setIsLoading(true);
    try {
      const responseData = await getAllStores(page, pageSize, query ? query : "");
      if (responseData?.data?.stores?.length === pageSize) {
        setStoresData(responseData?.data?.stores);
      } else {
        setStoresData(responseData?.data?.stores);
      }
      setTotalCount(responseData?.data?.total_count);
    } catch (error) {
      setIsLoading(false);
      showMessage("error", error?.response?.data?.message || "Something went wrong");
    }
    setIsLoading(false);
  }, [currentPage, searchQuery]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);


  const handleShow = (index) => {
    setClickedIndex(index);
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
    setToggleStatus(false);
    fetchData();
  };
  const handleConfirm = async (id) => {
    try {
      const sendBody = {
        are_credentials_active: toggleStatus,
      };
      await updateStore(id, sendBody);
      showMessage("success", "Store Updated Successfully");
      setToggleStatus(true);
      handleClose();
      fetchData();
    } catch (error) {
      showMessage("error", error?.response?.data?.message || "Something went wrong");
    }
  };

  return {
    isLoading,
    handleSearch,
    searchText,
    setSearchText,
    storesData,
    currentPage,
    pageSize,
    navigate,
    totalPages,
    handlePageChange,
    setToggleStatus,
    showModal,
    clickedIndex,
    handleClose,
    handleConfirm,
    handleShow,
  }
}
export default useHomeViewController;